enum NoteContactTime {
    Morning = '00000000-0000-0000-0000-000000000001',
    Afternoon = '00000000-0000-0000-0000-000000000002',
    Evening = '00000000-0000-0000-0000-000000000003',
}

export { NoteContactTime };
